import type { EditControlProps } from '../../declare'
import { useState, useEffect } from 'react'
import { autorun } from 'mobx'
import { Checkbox, Switch } from 'antd'
import { appStore } from 'src/stores'

const CheckboxControl = (props: EditControlProps) => {
  const [options, setOptions] = useState([])
  useEffect(() => autorun(() => {
    const { __CONTEXT__: editTable } = props.config
    const find = editTable.activeTableConfig?.Nav_Enums?.find((item: any) => item.EnumName === props.config.ENUM)
    if (find?.options) {
      setOptions(find.options)
    } else {
      appStore.getEnums([props.config.ENUM]).then((data: any[]) => {
        setOptions(appStore.getEnumOptions(props.config.ENUM, data))
      })
    }
  }), [props.config.ENUM])

  const handleGroupChange = (checkedValue: any[]) => {
    props.onChange?.(checkedValue.join(','))
  }

  const handleSwitchChange = (checked: boolean) => {
    props.onChange?.(checked)
  }

  const { __READONLY__, EDITABLE, ENUM } = props.config
  const disabled = __READONLY__ || !EDITABLE

  if (ENUM) {
    return (
      <Checkbox.Group
        disabled={disabled}
        value={props.value.split(',')}
        options={options}
        onChange={handleGroupChange}
      />
    )
  }

  return (
    <Switch
      disabled={disabled}
      checked={props.value}
      onChange={handleSwitchChange}
    />
  )
}

export default CheckboxControl
